import { graphql } from "msw";
import projects from "../data/oms/projects";
import userProjects from "../data/oms/userProjects";
import currencies from "../data/oms/currencies";

export const handlers = [
  graphql.query("getProjects", (req, res, ctx) => {
    return res(
      ctx.data({
        getProjects: projects,
      })
    );
  }),
  graphql.query("getProjectsForUser", (req, res, ctx) => {
    return res(
      ctx.data({
        getProjectsForUser: userProjects,
        getCurrencies: currencies,
      })
    );
  }),
];
